export default {
  title: "Trascrizioni agente vocale",
  description:
    "Conversazioni kiosk per la revisione prodotto. Nessuna identità di device o ospite è salvata.",
  empty: "Nessuna trascrizione ancora.",
  loadError: "Impossibile caricare le trascrizioni",
  detailLoadError: "Impossibile caricare questa trascrizione",
  selectPrompt: "Seleziona una conversazione per leggerla.",
  endedWith: {
    user_stop: "Terminata dall’ospite",
    error: "Errore",
    time_limit: "Limite di tempo",
  },
  meta: {
    language: "Lingua",
    duration: "Durata",
    turns: "Turni",
    activities: "Attività consigliate",
    none: "Nessuna",
  },
  roles: {
    user: "Ospite",
    assistant: "Agente",
    recommendations: "Consigliate",
  },
} as const;
